import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { GenAIOpsHubPaths } from '../../../constants';

export enum AllocationRoutes {
  Teams = '/teams',
  Projects = '/projects',
  Contributors = '/contributors',
  UserLookup = '/user-lookup',
  ContributorQuality = '/contributor-quality',
  Cohorts = '/cohorts',
}

export enum AllocationProjectsRoutes {
  PROJECTS = 'projects',
  PROJECT_GROUPS = 'project-groups',
}

interface AllocationSidebarMenuItem {
  icon: FontAwesomeIconProps['icon'];
  id: string;
  title: string;
  path: string;
}

export const AllocationSidebarMenuItems: AllocationSidebarMenuItem[] = [
  {
    id: 'contributors',
    title: 'Contributors',
    path: AllocationRoutes.Contributors,
    icon: 'person',
  },
  {
    id: 'teams',
    title: 'Worker Teams',
    path: AllocationRoutes.Teams,
    icon: 'people',
  },
  {
    id: 'projects',
    title: 'Projects',
    path: AllocationRoutes.Projects,
    icon: 'files',
  },
  {
    id: 'user-lookup',
    title: 'User lookup',
    path: AllocationRoutes.UserLookup,
    icon: 'user',
  },
  {
    id: 'contributor-quality',
    title: 'Contributor Quality',
    path: AllocationRoutes.ContributorQuality,
    icon: 'users',
  },
  {
    id: 'cohorts',
    title: 'Contributor Cohorts',
    path: AllocationRoutes.Cohorts,
    icon: 'people-group',
  },
];

export function routeForTeam(teamId: string): string {
  return `${GenAIOpsHubPaths.Allocation}${AllocationRoutes.Teams}/${teamId}`;
}

export function routeForProjectGroup(projectGroupId: string): string {
  return `${GenAIOpsHubPaths.Allocation}${AllocationRoutes.Projects}/${AllocationProjectsRoutes.PROJECT_GROUPS}/${projectGroupId}`;
}

export function routeForProjectGroups(): string {
  return `${GenAIOpsHubPaths.Allocation}${AllocationRoutes.Projects}/${AllocationProjectsRoutes.PROJECT_GROUPS}`;
}

export function routeForUser(userId: string): string {
  return `${GenAIOpsHubPaths.Allocation}${AllocationRoutes.UserLookup}/${userId}`;
}
